import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import GenericPromises from '../../../../api/GenericPromises';
import { Menuitem } from '../../../../interfaces/Security/menu';
import { Spinner } from '../../../../components/Commons/Spinner/Spinner';
import { Header } from '../../../../components/Header';
import { Button } from '@mui/material';
import { usePermissions } from '../../../../hooks/usePermissions';
import { TariffFraction } from '../../../../interfaces/Sales/Catalogs/tariffFractions';
import { UpdateTariffFractions } from './update';
import { GenericDialog } from '../../../../components/Dialogs/Dialog';
import { ButtonStyled } from '../../../../theme/buttons';
import useSnackBar from '../../../../components/Commons/SnackBar/useSnackBar';

export const ViewTariffFractions = () => {

    const [t] = useTranslation("global");
    const location = useLocation();
    const navigate = useNavigate();
    const [tariffFractionLocal, setTariffFractionLocal] = useState<TariffFraction>();
    const [openDialog, setOpenDialog] = useState(false);
    const [dataloaded, setDataLoaded] = useState(false);
    const { GenericGetResource, GenericDeleteResource } = GenericPromises();
    const [resourceScreen, setResourceScreen] = useState<Menuitem>();
    const { showSnackBar, SnackbarComponent } = useSnackBar();

    const { GetResourceByUrl } = usePermissions();







    const onDelete = () => {
        GenericDeleteResource(`/tarifffractions/${tariffFractionLocal?.tariff_fraction_id}`)
            .then(() => {
                setOpenDialog(false);
                navigate("/tarifffractions", { state: { method: "delete" }, replace: true });
            })
            .catch((error) => {
                showSnackBar(error.message, 'error');
                setOpenDialog(false);
            })
    }


    useEffect(() => {
        if (location.state === null) return navigate("/tarifffractions", { state: {}, replace: true });
        GenericGetResource(`/tarifffractions/${location.state.row.tariff_fraction_id}`)
            .then(
                (response) => {
                    setTariffFractionLocal(response.data);

                    GetResourceByUrl(`/tarifffractions`)
                        .then((response1) => {
                            setResourceScreen((prev) => response1);
                            setDataLoaded(true);
                        })
                        .catch((error) => {
                            showSnackBar(error.message, 'error');
                        });
                }
            ).catch((error) => {
                showSnackBar(error.message, 'error');
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {!dataloaded && <Spinner />}
            {dataloaded &&
                <>
                    <Header
                        title={t("tarifffractions.title-view")}
                        child={
                            <div className='d-flex flex-row-reverse m-1'>
                                {resourceScreen?.delete === true &&
                                    <ButtonStyled variant="contained" className="my-1" onClick={() => setOpenDialog(true)}>{t("generic.buttons.delete")}</ButtonStyled>
                                }
                                <Button variant="outlined" onClick={() => { navigate("/tarifffractions", { replace: true }) }}>{t("generic.buttons.goback")}</Button>
                            </div>
                        }
                    />
                    {resourceScreen?.read &&
                        <>
                            <div>
                                <UpdateTariffFractions tariffFractionPayload={tariffFractionLocal} isEdit={resourceScreen?.update} />
                            </div>
                        </>
                    }
                </>
            }
            <GenericDialog
                title={t("generic.dialog.delete")}
                content={t("tarifffractions.dialog.delete")}
                open={openDialog}
                setOpen={setOpenDialog}
                onAcept={onDelete}
            />
            <SnackbarComponent />
        </>
    )
}
